/**
 * Form hanya jika laka lantas
 */

import { Grid } from "@material-ui/core";
import {
  InputOptionMaster,
  InputTextMaster,
  MasterButton,
} from "App/Component/ui";
import { isNull } from "App/utils/helpers";
import { useKabupaten, useKecamatan, useProvinsi } from "./hooks";
import React from "react";
import { suplesiSelect } from "../../../utils";
import { SelectIcon } from "App/Assets";

export const FormHanyaJikaLakaLantas = ({
  formData,
  setFormData,
  handleChange,
  handleClickSepSuplesi,
}) => {
  const kabupaten = useKabupaten(formData.kode_propinsi);
  const kecamatan = useKecamatan(formData.kode_kabupaten);
  const provinsi = useProvinsi();

  if (parseInt(formData.laka_lantas) !== 0) {
    return (
      <>
        <Grid item sm={12}>
          <InputTextMaster
            name="keterangan"
            label="KETERANGAN"
            id="keterangan"
            value={formData.keterangan}
            onChange={handleChange("keterangan")}
            placeholder="Keterangan"
          />
        </Grid>

        <Grid item sm={parseInt(formData?.laka_lantas) === 3 ? 12 : 4}>
          <InputTextMaster
            name="tgl_kejadian"
            label="TANGGAL KEJADIAN"
            id="tgl_kejadian"
            type="date"
            value={formData.tgl_kejadian}
            onChange={handleChange("tgl_kejadian")}
            placeholder="tgl_kejadian"
          />
        </Grid>

        {parseInt(formData?.laka_lantas) !== 3 ? (
          <>
            <Grid item sm={formData.suplesi === 1 ? 4 : 8}>
              <InputOptionMaster
                name="suplesi"
                label="SUPLESI"
                id="suplesi"
                value={formData.suplesi}
                labelValue={formData.nama_suplesi}
                withSearch={true}
                onChange={(e) => {
                  isNull(e)
                    ? setFormData({
                        ...formData,
                        suplesi: "",
                        nama_suplesi: "",
                      })
                    : setFormData({
                        ...formData,
                        suplesi: e.value,
                        nama_suplesi: e.label,
                      });
                }}
                data={suplesiSelect}
              />
            </Grid>

            {formData.suplesi === 1 ? (
              <>
                <Grid item sm={4}>
                  <div
                    style={{
                      display: "flex",
                    }}
                  >
                    <InputTextMaster
                      name="nomor_sep_suplesi"
                      label="NOMOR SEP SUPLESI"
                      id="nomor_sep_suplesi"
                      value={formData.nomor_sep_suplesi}
                      onChange={handleChange("nomor_sep_suplesi")}
                      placeholder="Nomor Sep Suplesi"
                    />
                    <MasterButton
                      type={"button"}
                      color="lightgreen"
                      name=""
                      size="sm"
                      withIcon={true}
                      onClick={() => handleClickSepSuplesi()}
                      style={{
                        marginTop: "1.5rem",
                        width: "32px",
                        height: "32px",
                      }}
                      icon={
                        <SelectIcon
                          width="16px"
                          height="16px"
                          style={{
                            marginLeft: "-0.5rem",
                          }}
                        />
                      }
                    />
                  </div>
                </Grid>
              </>
            ) : (
              <></>
            )}
          </>
        ) : (
          <></>
        )}

        {parseInt(formData?.laka_lantas) !== 3 ? (
          <>
            <Grid item sm={12}>
              <Grid container spacing={1}>
                <Grid item sm={4}>
                  <InputOptionMaster
                    name="kode_propinsi"
                    label="PROVINSI LAKA LANTAS"
                    id="kode_propinsi"
                    value={formData.kode_propinsi}
                    withSearch={true}
                    labelValue={formData.nama_propinsi}
                    onChange={(e) => {
                      if (isNull(e)) {
                        setFormData({
                          ...formData,
                          kode_propinsi: null,
                          nama_propinsi: "Pilih Provinsi",
                          kode_kabupaten: null,
                          nama_kabupaten: "Pilih Kabupaten",
                          kode_kecamatan: null,
                          nama_kecamatan: "Pilih Kecamatan",
                        });
                      } else {
                        setFormData({
                          ...formData,
                          kode_propinsi: e.value,
                          nama_propinsi: e.label,
                          kode_kabupaten: null,
                          nama_kabupaten: "Pilih Kabupaten",
                          kode_kecamatan: null,
                          nama_kecamatan: "Pilih Kecamatan",
                        });
                      }
                    }}
                    data={provinsi}
                  />
                </Grid>
                <Grid item sm={4}>
                  <InputOptionMaster
                    name="kode_kabupaten"
                    label="KABUPATEN LAKA LANTAS"
                    id="kode_kabupaten"
                    value={formData.kode_kabupaten}
                    withSearch={true}
                    labelValue={formData.nama_kabupaten}
                    onChange={(e) => {
                      if (isNull(e)) {
                        setFormData({
                          ...formData,
                          kode_kecamatan: null,
                          nama_kecamatan: "Pilih Kecamatan",
                          kode_kabupaten: null,
                          nama_kabupaten: "Pilih Kabupaten",
                        });
                      } else {
                        setFormData({
                          ...formData,
                          kode_kabupaten: e.value,
                          nama_kabupaten: e.label,
                          kode_kecamatan: null,
                          nama_kecamatan: "Pilih Kecamatan",
                        });
                      }
                    }}
                    data={kabupaten}
                  />
                </Grid>
                <Grid item sm={4}>
                  <InputOptionMaster
                    name="kode_kecamatan"
                    label="KECAMATAN LAKA LANTAS"
                    id="kode_kecamatan"
                    value={formData.kode_kecamatan}
                    withSearch={true}
                    labelValue={formData.nama_kecamatan}
                    onChange={(e) => {
                      if (isNull(e)) {
                        setFormData({
                          ...formData,
                          kode_kecamatan: null,
                          nama_kecamatan: "Pilih Kecamatan",
                        });
                      } else {
                        setFormData({
                          ...formData,

                          kode_kecamatan: e.value,
                          nama_kecamatan: e.label,
                        });
                      }
                    }}
                    data={kecamatan}
                  />
                </Grid>
              </Grid>
            </Grid>
          </>
        ) : (
          <></>
        )}
      </>
    );
  } else {
    return <></>;
  }
};
